<template>
  <q-dialog ref="dialog" @hide="onDialogHide">
    <q-card class="q-dialog-plugin">
      <q-bar class="toolbar">
        <span class="toolbar-title">
          {{ title }}
        </span>

        <q-space />

        <q-btn :disable="!newField" color="tertiary" size="sm" label="Save" @click="save" />

        <div class="btn-wrapper">
          <q-btn data-cy="close-dialog-btn" flat round icon="fal fa-times" @click="hide">
            <LmTooltip>Close</LmTooltip>
          </q-btn>
        </div>
      </q-bar>

      <q-card-section>
        <q-input v-model.trim="newField" autofocus label="FTE field" outlined @keyup.enter="save" />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },

  data: () => ({
    newField: ''
  }),

  methods: {
    show() {
      this.$refs.dialog.show()
    },

    hide() {
      this.$refs.dialog.hide()
    },

    onDialogHide() {
      this.$emit('hide')
    },

    save() {
      if (!this.newField.trim()) return
      this.$emit('ok', this.newField)
      this.newField = ''
      this.hide()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/variables'

.dialog-card {
  display grid
  grid-template-rows auto 1fr
}
.toolbar {
  background: $white
  padding 0 16px
  height 46px
  font-size 21px
  color $dark
  border-radius 0
  border 1px solid $lighter-grey
  .toolbar-title {
    font-family 'Barlow', sans-serif
  }
}
.q-dialog {
  .q-dialog__inner > div {
    overflow visible
    border-radius 0
  }
}
</style>
